import FinishedCallGuard from '../components/FinishedCallGuard';
import ConsentTermContainer from '../features/ConsentTerm';
import HomeContainer from '../features/Home';
import TelemedicineFinishedContainer from '../features/TelemedicineFinished';
import VideoRoomContainer from '../features/VideoRoom';
import WaitingRoomContainer from '../features/WaitingRoom';
import Root from '../Root';

import { createBrowserRouter, Navigate } from 'react-router-dom';

export const createRouter = () => createBrowserRouter([{
	element: <Root />,
	path: '/',
	children: [{
		element: <Navigate replace to="/home" />,
		path: '/',
		index: true
	}, {
		element: <HomeContainer />,
		path: '/home'
	}, {
		element: <ConsentTermContainer />,
		path: '/consent-term'
	}, {
		element: <FinishedCallGuard><WaitingRoomContainer /></FinishedCallGuard>,
		path: '/waiting-room'
	}, {
		element: <TelemedicineFinishedContainer />,
		path: '/telemedicine-finished'
	}, {
		element: <FinishedCallGuard><VideoRoomContainer /></FinishedCallGuard>,
		path: '/video-room'
	}]
}]);
